module.exports = __webpack_public_path__ + "img/dc6.d8a43ef9.png";